import { HTTP_STATUS } from 'src/constants/httpStatus';

export const CHAT_SCOPE = Object.freeze({
    GENERAL: 'general',
    LEAD: 'lead',
} as const);

export const MESSAGE_ROLE = Object.freeze({
    USER: 'user',
    ASSISTANT: 'assistant',
} as const);

export const MESSAGE_KIND = Object.freeze({
    TEXT: 'text',
    NEXT_ACTION: 'next_action',
    ACTION_DRAFT: 'action_draft',
} as const);

export const NEXT_ACTION_PROMPT = 'Determinar la próxima acción del lead';
export const CONVERSATIONS_PATH = '/conversations';

export const RECOMMENDATION_ACTION = Object.freeze({
    CONTACT: 'contact',
    SEND_QUOTE: 'send_quote',
    SEND_TEMPLATE: 'send_template',
    SCHEDULE_TEST_DRIVE: 'schedule_test_drive',
    CONFIRM_APPOINTMENT: 'confirm_appointment',
    FOLLOW_UP: 'follow_up',
    REACTIVATE: 'reactivate',
    ESCALATE: 'escalate',
    WAIT: 'wait',
    INSUFFICIENT_DATA: 'insufficient_data',
} as const);

export const ASSISTANT_INTENT_QUERY = 'assistantAction';
export const ASSISTANT_TEMPLATE_CATEGORY_QUERY = 'assistantTemplateCategory';
export const ASSISTANT_TEMPLATE_ID_QUERY = 'assistantTemplateId';
export const ASSISTANT_REQUEST_ID_QUERY = 'assistantRequestId';
export const ASSISTANT_INTENT = Object.freeze({
    CONVERSATION: 'conversation',
    APPOINTMENT: 'appointment',
    VIEW_APPOINTMENT: 'view_appointment',
    TASK: 'task',
    WHATSAPP: 'whatsapp',
    ASSIGN: 'assign',
} as const);

export const RECOMMENDATION_MAX_AGE_MS = 24 * 60 * 60 * 1000;

export const RECOMMENDATION_FEEDBACK = Object.freeze({
    USEFUL: 'useful',
    NOT_USEFUL: 'not_useful',
} as const);

export const RECOMMENDATION_TIMING = Object.freeze({
    NOW: 'now',
    TODAY: 'today',
    NEXT_24_HOURS: 'next_24_hours',
    THIS_WEEK: 'this_week',
    NO_RUSH: 'no_rush',
} as const);

export const RECOMMENDATION_TARGET = Object.freeze({
    CONVERSATION: 'conversation',
    WHATSAPP_TEMPLATE: 'whatsapp_template',
    APPOINTMENT: 'appointment',
    EXISTING_APPOINTMENT: 'existing_appointment',
    TASK: 'task',
    ASSIGNMENT: 'assignment',
    NONE: 'none',
} as const);

export type TChatScope = (typeof CHAT_SCOPE)[keyof typeof CHAT_SCOPE];

/**
 * i18n key of the error shown for each HTTP status returned by the assistant endpoints.
 */
export const ASSISTANT_ERROR_BY_STATUS: Readonly<Record<number, string>> =
    Object.freeze({
        [HTTP_STATUS.FORBIDDEN]: 'Assistant.ErrorAccess',
        [HTTP_STATUS.NOT_FOUND]: 'Assistant.ErrorLeadNotFound',
        [HTTP_STATUS.TOO_MANY_REQUESTS]: 'Assistant.ErrorRateLimit',
        [HTTP_STATUS.SERVICE_UNAVAILABLE]: 'Assistant.ErrorUnavailable',
    });
